import React, { Component, Fragment } from 'react';
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer} from 'recharts'
import { translate, I18n } from 'react-i18next'
import Spinner from '../../components/Spinner'

const CustomTooltip = ({active, payload, label}) => {
  if (active) {
    return (
      <I18n>
        {
          t => (
            <div className="chart-tooltip" style={{backgroundColor: "white", fontWeight: "bold", fontSize: "12px"}}>
              <p className="label">{`${label} : ${payload[0].value}`}</p>
              <p className="volume">{t('custom:customGPWChart.volume')}: {payload[0].payload.volume}</p>
            </div>
          )
        }
      </I18n>
    )
  }

  return null
}

class CustomizedAxisTick extends Component {
  render() {
    const { x, y, stroke, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="end" fontSize={14} fill="#666" transform="rotate(-35)">
          {payload.value}
        </text>
      </g>
    );
  }
}

class VCCustomGPWChart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: []
    }
  }

  async componentDidMount() {
    try {
      await fetch("https://api.ws-com.red.com.pl/stocks")
      .then(response => response.json())
      .then(json => this.setState({data: json.reverse()}))
    } catch (error) {
      console.log(error);
    }
  }

  // static getDerivedStateFromProps(props, state) {
  //   // FIXME: if is fetching?
  //   const pagination = props.pagination['stockPrices']
  //   if (pagination === undefined) return null

  //   const entities = props.entities
  //   if (entities === undefined) return null

  //   if (pagination.code !== null && pagination.code !== 200) return null

  //   const lastPrice = function (entity) {
  //     if (!entity) return { }
  //     return {
  //       value: entity.getValue(),
  //       change: entity.getChange(),
  //       date: entity.getDate(),
  //       volume: entity.getVolume(),
  //     }
  //   }

  //   return {
  //     lastPrice: lastPrice(props.entities[pagination.ids[pagination.ids.length - 1]]),
  //     chartData: pagination.ids.filter(id => props.entities[id] !== undefined).map(id => ({
  //       date: props.entities[id].getDate(),
  //       value: props.entities[id].getValue(),
  //       volume: props.entities[id].getVolume()
  //     })),
  //     prevPage: pagination.prevPage,
  //     nextPage: pagination.nextPage,
  //   }
  // }
  render() {
    if (this.state.data.length === 0)
      return <Spinner>{this.props.t('custom:customGPWChart.loading')}</Spinner>

    return (
      <Fragment>
        <h2 style={{padding: "20px 0"}}>{this.props.t('custom:customGPWChart.title')}</h2>
        <p>GI Group Poland S.A. (GIG)</p>
        <div>
          {/* <div className="info col-lg-6">
            {this.state.lastPrice ?
              <Fragment>
                <div className="row changes">
                  <div className="latest col-md-6"><h3>{this.props.t('custom:customGPWChart.latest')}:</h3></div>
                  <div className="change col-md-6"><h3>{this.props.t('custom:customGPWChart.change')}:</h3></div>
                </div>
                <div className="row changes">
                  <div className="latest col-md-6"><span>{this.state.lastPrice.value}</span></div>
                  <div className="change col-md-6"><span>{this.state.lastPrice.change}</span></div>
                </div>
                <div className="time"><span>{this.props.t('custom:customGPWChart.time')}:</span> {this.state.lastPrice.date}</div>
                <div className="current"><span>{this.props.t('custom:customGPWChart.current')}:</span> {this.state.lastPrice.value}</div>
                <div className="volume"><span>{this.props.t('custom:customGPWChart.volume')}:</span> {this.state.lastPrice.volume}</div>
              </Fragment>
            : null}
          </div> */}

          <div>
            <div className="chart" style={{fontSize: "10px", width: "100%", height: "300px"}}>
              <ResponsiveContainer width="100%">
                <LineChart data={this.state.data} margin={{top: 5, right: 30, left: 10, bottom: 10}}>
                  <XAxis
                    dataKey="date"
                    allowDataOverflow={true}
                    height={60}
                    tick={<CustomizedAxisTick />}
                  />
                  <YAxis
                    domain={['dataMin + 0.01', 'dataMax + 0.01']}
                    type="number"
                    tick={{stroke: '#22376F', strokeWidth: 0.2, fontSize: "14px"}}
                    padding={{ top: 30, bottom: 30 }}
                  />
                  <CartesianGrid
                    stroke="#22376F"
                    strokeWidth={0.5}
                    strokeDasharray="5 5"
                  />
                  <Tooltip
                    content={<CustomTooltip />}
                  />
                  <Line type="monotone" dataKey="close" stroke="#4ec63e" activeDot={{ r: 8 }} />
                </LineChart>
              </ResponsiveContainer>
            </div>

            <div className="legend" style={{padding: "20px 0"}}>
              {this.props.t('custom:customGPWChart.legend')}
            </div>

            {/* <div className="navigation">
              {this.state.nextPage ?
                <a className="prev" onClick={e => this.props.findStockPrices({ page: this.state.nextPage, target: 'stockPrices' })}>{this.props.t('custom:customGPWChart.prev')}</a>
              : null }
              {this.state.prevPage ?
                <a className="next" onClick={e => this.props.findStockPrices({ page: this.state.prevPage, target: 'stockPrices' })}>{this.props.t('custom:customGPWChart.next')}</a>
              : null }
            </div> */}

          </div>
        </div>
      </Fragment>
    )
  }
}

export default translate()(VCCustomGPWChart)


// WEBPACK FOOTER //
// ./src/custom/components/VCCustomGPWChart.js